import { TNote } from '@ws/shared/types';
import { useRef } from 'react';

import { IWriteBoardEditorHandle, WriteBoardEditor } from '../../../components';

import { WriteBoardTemplate } from './WriteBoardTemplate';

interface IWriteBoardContainerProps {
  note: TNote;
}

export function WriteBoardContainer({ note }: IWriteBoardContainerProps) {
  const editorHandleRef = useRef<IWriteBoardEditorHandle | null>(null);

  const handleContentClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (event.target !== event.currentTarget) {
      return;
    }

    // Клик в пустую область ниже текста — переносим курсор в конец документа,
    // т.к. contentEditable-обёртка не растягивается на всю высоту, когда заметка короткая.
    editorHandleRef.current?.focusAtEnd();
  };

  return (
    <WriteBoardTemplate
      onContentClick={handleContentClick}
      contentView={<WriteBoardEditor ref={editorHandleRef} note={note} />}
    />
  );
}
